import type { Blank } from 'store/types/common';

import { InfoCard } from '../../ui-kit/info-card';
import { GOAL, GOAL_TITLE, PLAN, PROGRAM } from '../constants';

import { ClientGoalHistory, ClientGoalHistorySheet } from './client-blank-goal-history';

import styles from './styles.module.scss';
import { Button, Icon, Sheet } from '@gravity-ui/uikit';
import { useState } from 'react';
import { ChevronRight, TargetDart, Xmark } from '@gravity-ui/icons';
import { getLatestByDateAndId } from 'shared/utils/get-latest-by-date-and-id';

interface ClientGoalProps {
	data: Blank;
}

export const ClientGoalSheet = ({ data }: ClientGoalProps) => {
	const [open, setOpen] = useState(false);

	// Находим patientEstimate с самой поздней датой (при равных датах - с большим ID)
	const lastEstimate = getLatestByDateAndId(data.patientEstimates);

	return (
		<>
			<Button size="xl" view="outlined" onClick={() => setOpen(true)} className={styles.sheet_btn_open}>
				<Icon data={TargetDart} size={20} />
				{GOAL_TITLE}
				<Icon data={ChevronRight} size={20} />
			</Button>
			<Sheet visible={open} onClose={() => setOpen(false)} className={styles.sheet}>
				<div className={styles.goal}>
					<div className={styles.goal__close}>
						<h3 className={styles.goal__title}>{GOAL_TITLE}</h3>
						<Button onClick={() => setOpen(false)} view="flat">
							<Icon data={Xmark} size={16} />
						</Button>
					</div>

					<InfoCard
						className={styles.goal__card}
						values={[
							[
								GOAL,
								data.patientEstimates.length > 0 ? lastEstimate?.goal : '-',
								data.patientEstimates.length > 1 ? (
									<ClientGoalHistorySheet history={data.patientEstimates} />
								) : undefined,
							],
							[PROGRAM, data.program],
							[PLAN, data.patientEstimates.length > 0 ? lastEstimate?.goalPlan : '-'],
						]}
					/>
				</div>
			</Sheet>
		</>
	);
};
